module.exports = __webpack_public_path__ + "static/media/Main.58c16e45.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/pages/Boards/assets/Main.jpeg
// module id = 217
// module chunks = 0